//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import * as gatewayAuthenticationApi from '@apis/auth/gatewayAuthenticationApi';

import { GetNgApiAdapterType, createNgApiAdapterService } from 'app/angular-apis/createNgApiAdapter';

const gatewayAuthenticationApiService = createNgApiAdapterService(gatewayAuthenticationApi);
export type GatewayAuthenticationApiService = GetNgApiAdapterType<typeof gatewayAuthenticationApiService>;

angular.module('curalate').service('GatewayAuthenticationApiService', gatewayAuthenticationApiService);
